export default __webpack_public_path__ + "static/media/success-purchase.ac7a4887.svg";